import { RotateCcw, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '../shared/ui';

/** Last-resort screen when the app itself fails to render. Work is already saved locally. */
export function AppCrashed() {
  const { t } = useTranslation();
  return (
    <main className="flex h-full items-center justify-center bg-bg-0">
      <EmptyState
        icon={<TriangleAlert />}
        title={t('errors.appFailed')}
        body={t('errors.appFailedBody')}
        action={
          <Button
            variant="primary"
            leadingIcon={<RotateCcw />}
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('errors.reload')}
          </Button>
        }
      />
    </main>
  );
}
